const FileValidationEnum = Object.freeze({
    FILE_SIZE_LIMIT: 5 * 1024 * 1024,
    MAX_FILES_LIMIT: 5,
    MAX_FILENAME_LENGTH: 255,
    ALLOWED_FILE_TYPES: [
      'image/jpeg', 
      'image/jpg',
      'image/png', 
      'application/pdf', 
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
      'application/vnd.ms-excel', 
      'text/csv', 
      'application/msword', 
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      'text/plain', 
    ],
  });
  
  module.exports = FileValidationEnum;
  